module.exports = __webpack_public_path__ + "static/media/template-around-kumbakonam.eb17df13.jpg";